export enum HostCardSurveyStep {
	General,
	PropertyStatus,
	RegistrationAddress,
	HomeAddress,
	SocialStatus,
	LastQuestions,
}
